import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    MenuItem,
    Box,
    Autocomplete
} from "@mui/material";
import { put } from "src/services/httpClient.service";

import { post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import CircularProgress from "@mui/material/CircularProgress";

interface Props {
    open: boolean;
    onClose: () => void;
    data: any;
    districts: any[];
    cities: any[];
    onSuccess: () => void;
}

const API_URL = process.env.REACT_APP_BASE_API_URL;

const UpdateMediaServer = ({
    open,
    onClose,
    data,
    districts,
    cities,
    onSuccess,
}: Props) => {
    const { showSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const [loadingCities, setLoadingCities] = useState(false);
    const [selectedCityInput, setSelectedCityInput] = useState('');
    // const [selectedCityId, setSelectedCityId] = useState('');
    // const [selectedCityName, setSelectedCityName] = useState('');
    // const [selectedDistrictId, setSelectedDistrictId] = useState('');
    // const [selectedDistrictName, setSelectedDistrictName] = useState('');


    const [formData, setFormData] = useState<any>({
        id: "",
        name: "",
        url: "",
        status: "ACTIVE",
        districtId: '',
        districtName: '',
        cityId: '',
        cityName: '',
        stateId: '',
        stateName: '',
        serverUserName: "",
        serverPassword: "",
        vendorId: "",
    });

    useEffect(() => {
        if (data) {
            setFormData({
                id: data.id,
                name: data.name || "",
                url: data.url || "",
                status: data.status || "ACTIVE",
                districtId: data.districtId || "",
                cityId: data.cityId || "",
                stateId: data.stateId || "",
                districtName: data.districtName || "",
                cityName: data.cityName || "",
                stateName: data.stateName || "",
                serverUserName: data.serverUserName || "",
                serverPassword: data.serverPassword || "",
                vendorId: data.vendorId,
            });
        }
    }, [data]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleUpdate = async () => {
        setLoading(true);

        try {
            const payload = {
                id: formData.id,
                name: formData.name?.trim(),
                url: formData.url?.trim(),
                cityId: formData.cityId,
                cityName: formData.cityName?.trim(),
                districtId: formData.districtId,
                districtName: formData.districtName?.trim(),
                stateId: formData.stateId,
                stateName: formData.stateName?.trim(),
                status: formData.status,
                serverUserName: formData.serverUserName,
                serverPassword: formData.serverPassword,
                vendorId: formData.vendorId
            };

            const response = await put(
                `${API_URL}/api/vendor-media-servers/${formData.id}`,
                payload
            );

            showSnackbar(
                response?.message || "Media Server Updated Successfully",
                "success"
            );

            onSuccess();
            onClose();
        } catch (error: any) {
            console.log('error',error)
            showSnackbar(
                error?.response?.data ||
                error?.message ||
                "Failed to save media Server",
                "error"
            );
        }finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                Update Media Server
            </DialogTitle>

            <DialogContent>

                <Grid container spacing={2} mt={1}>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Server Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Server URL"
                            name="url"
                            value={formData.url}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Username"
                            name="serverUserName"
                            value={formData.serverUserName}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="password"
                            label="Password"
                            name="serverPassword"
                            value={formData.serverPassword}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="Status"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <MenuItem value="ACTIVE">
                                ACTIVE
                            </MenuItem>

                            <MenuItem value="INACTIVE">
                                INACTIVE
                            </MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box>
                            <Autocomplete
                                options={cities}
                                value={
                                    cities.find(c => String(c.id) === String(formData.cityId)) || null
                                }
                                getOptionLabel={(option) =>
                                    `${option.city} / ${option.districtName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
                                }
                                isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                }
                                onChange={(_, value) => {
                                    if (!value) {
                                        setFormData(prev => ({
                                            ...prev,
                                            cityId: "",
                                            cityName: "",
                                            districtId: "",
                                            districtName: "",
                                            stateId: "",
                                            stateName: ""
                                        }));
                                        return;
                                    }

                                    setFormData(prev => ({
                                        ...prev,
                                        cityId: value.id,
                                        cityName: value.city,
                                        districtId: value.districtId,
                                        districtName: value.districtName,
                                        stateId: value.stateId,
                                        stateName: value.stateName
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="City" />
                                )}
                            />
                            
                            </Box>  
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="District"
                            name="districtId"
                            value={formData.districtId}
                            onChange={handleChange}
                        >
                            {districts.map((district: any) => (
                                <MenuItem
                                    key={district.id}
                                    value={district.id}
                                >
                                    {district.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="City"
                            name="cityId"
                            value={formData.cityId}
                            onChange={handleChange}
                        >
                            {cities.map((city: any) => (
                                <MenuItem
                                    key={city.id}
                                    value={city.id}
                                >
                                    {city.city}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid> */}

                </Grid>

            </DialogContent>

            <DialogActions>

                <Button onClick={onClose}>
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleUpdate}
                    disabled={loading}
                    startIcon={
                        loading ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : null
                    }
                >
                    {loading ? "Updating..." : "Update"}
                </Button>

            </DialogActions>

        </Dialog>
    );
};

export default UpdateMediaServer;